// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,

 //redirectUri: 'http://localhost:4200/index',
 redirectUri: 'https://bienestardesa.junji.gob.cl/login',
  

//QA:
 clientId: 'a45d2d2d-442d-4cb2-8297-f0261c6e5ae2',
 authority: 'https://login.microsoftonline.com/common',
 user:'extUser',
 pass:'$^-CBy',
 apiKey:'c43b4038-2c7f-407a-b1fe-49262eff6dc2',
 
 //API QA:
 urlApiCargas:'https://dockerdev.junji.gob.cl/excelcarga/v1',
 urlApiCargaFamiliar:'https://dockerdev.junji.gob.cl/familiarcarga/v1',
 urlApiUsuario:'https://dockerdev.junji.gob.cl/usuario/v1',
 urlApiSolicitudes:'https://dockerdev.junji.gob.cl/solicitudes/v1',
 urlApiAyudaMedica:'https://dockerdev.junji.gob.cl/ayuda-medica/v1',
 urlApiOperacion:'https://dockerdev.junji.gob.cl/operacion/v1',
 urlApiPrestamo:'https://dockerdev.junji.gob.cl/prestamo/v1',
 urlApiSubsidio:'https://dockerdev.junji.gob.cl/subsidio/v1',
 urlApipagos:'https://dockerdev.junji.gob.cl/pago/v1',
 //urlBase:'https://dockerdev.junji.gob.cl/bienestar/v1',
 urlBase:'https://dockeruat.junji.gob.cl/api-base-bienestar/v1',
 urlIntegracion:'https://dockerdev.junji.gob.cl/integracion',
 urlApiCoreservice:'https://dockerdev.junji.gob.cl/coreservice',
 urlApiClaveUnica: 'https://dockerdev.junji.gob.cl/claveUnica/v1',
 urlApiUpload: 'https://dockerdev.junji.gob.cl/uploader',
 urlApiAfiliacion: 'https://dockerdev.junji.gob.cl/afiliacion',

//Integracion clave unica
urlClaveUnica:'https://accounts.claveunica.gob.cl/',
//urlClaveUnicaToken
urlClaveUnicaToken:'https://accounts.claveunica.gob.cl/openid/token/',
 //Cliente Id entregado por claveunica
clienteId:'f854ec870e4e48528bbe91d9ba58555b',
//Client Secret entregado por claveunica
clientSecret:'b33b5a06546140e1a373ca8853d40dc3',
//URL a la cual se debe redirigir cuando la autenticacion es exitosa
claveRedirectUri:'https://bienestardesa.junji.gob.cl/aprobacion-solicitud-afiliacion',
//url clave unica logout
urlClaveUnicaLogout:'https://accounts.claveunica.gob.cl/api/v1/accounts/app/logout',
 

  //urlBlob: 'https://documentos-bienestar.azureedge.net/repobiene',
  urlBlob: 'https://arqblob.blob.core.windows.net/desarrollos',
  apikey: 'eyJ4NXQiOiJOVGRtWmpNNFpEazNOalkwWXpjNU1tWm1PRGd3TVRFM01XWXdOREU1TVdSbFpEZzROemM0WkE9PSIsImtpZCI6ImdhdGV3YXlfY2VydGlmaWNhdGVfYWxpYXMiLCJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJzdWIiOiJhZG1pbkBjYXJib24uc3VwZXIiLCJhcHBsaWNhdGlvbiI6eyJvd25lciI6ImFkbWluIiwidGllclF1b3RhVHlwZSI6bnVsbCwidGllciI6IlVubGltaXRlZCIsIm5hbWUiOiJhcHAtYmllbmVzdGFyLXN1YnNpZGlvcyIsImlkIjo0LCJ1dWlkIjoiM2YxYWMxODYtZTlkOC00YzY1LWJmYmQtMmVmZjMxZTE1NWYwIn0sImlzcyI6Imh0dHBzOlwvXC8xMC4zLjQuNjo5NDQzXC9vYXV0aDJcL3Rva2VuIiwidGllckluZm8iOnsiVW5saW1pdGVkIjp7InRpZXJRdW90YVR5cGUiOiJyZXF1ZXN0Q291bnQiLCJzdG9wT25RdW90YVJlYWNoIjp0cnVlLCJzcGlrZUFycmVzdExpbWl0IjowLCJzcGlrZUFycmVzdFVuaXQiOm51bGx9fSwia2V5dHlwZSI6IlNBTkRCT1giLCJzdWJzY3JpYmVkQVBJcyI6W3sic3Vic2NyaWJlclRlbmFudERvbWFpbiI6ImNhcmJvbi5zdXBlciIsIm5hbWUiOiJOb3RpZmljYXRpb25SRVNUQVBJIiwiY29udGV4dCI6Ilwvbm90aWZpY2F0aW9uXC92MSIsInB1Ymxpc2hlciI6ImFkbWluIiwidmVyc2lvbiI6InYxIiwic3Vic2NyaXB0aW9uVGllciI6IlVubGltaXRlZCJ9LHsic3Vic2NyaWJlclRlbmFudERvbWFpbiI6ImNhcmJvbi5zdXBlciIsIm5hbWUiOiJiaWVuZXN0YXItY2Mtc3Vic2lkaW8iLCJjb250ZXh0IjoiXC9iaWVuZXN0YXItY2Mtc3Vic2lkaW9cL3YxIiwicHVibGlzaGVyIjoiYWRtaW4iLCJ2ZXJzaW9uIjoidjEiLCJzdWJzY3JpcHRpb25UaWVyIjoiVW5saW1pdGVkIn1dLCJpYXQiOjE1OTQyNjkyMTgsImp0aSI6Ijg5ZjYzOGM1LWI3NjktNGIxZC04MDgwLTM0NzJiNjMxYzcyYiJ9.SB2F9-Zt9rzNWQKmVD3HcJ8ub2ZxyU94ieJu8_VFjAGBaXC2wRAFO4fKQeTsdemQTxs47O3jeKtKF0OeM7YtrsZzi4zS3D0fxUT7lYK8CE7R-woC6LxwqjLPaAn8jBDaXpJ7y3w7_V0vbD1jQZ-OzTWwHOe2EM867acQBBuH8zLl0i_YnPQkjkX90EE82gO0wAPeR7L2N4y8utxSHF409aeD1HWV3xOsa8OIMDnOxUXXTGjeW5lTjlw04cT80146DbtzQgC-KeWI531t_MO8T3WqXnVC12aFI2E41MMvTeLCe3chqLTTcQ2QVjjiqPhdAQDeoUGCvlIezxDiJHLeDQ=='
};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.